// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac770952","239":"46fa55cb","667":"a9e9b7b0"}[chunkId] + ".chunk.js";
};